<div mat-dialog-title class="dialog-header aum-typo-headline-3">
    <div class="dialog-title">
        <span class="title-span"
            >{{ 'aumico_reports_reorder_report_sections_dialog_title' | i18next }}
        </span>
    </div>
    <div class="seprator"></div>
    <div class="close-dialog">
        <mat-dialog-actions>
            <mat-icon (click)="closeDialog()" svgIcon="interface-delete 1"></mat-icon>
        </mat-dialog-actions>
    </div>
</div>
<div mat-dialog-content>
    <div cdkDropList class="section-list" (cdkDropListDropped)="changeSectionOrder($event)">
        <div *ngIf="reorderingReportData.showCoverPage" class="section-box-drag-disabled">
            {{ 'aumico_reports_reorder_report_cover_section_title' | i18next }}
        </div>
        <div *ngIf="reorderingReportData.showTOC" class="section-box-drag-disabled">
            {{ 'aumico_reports_annualreport_toc_label_table_of_contents' | i18next }}
        </div>
        <div
            class="section-box-dragged"
            *ngFor="let section of reorderedReportSections"
            cdkDrag
            cdkDragBoundary=".section-list"
        >
            <div *cdkDragPlaceholder></div>
            {{ section.title }}
            <mat-icon svgIcon="interface-drag" class="dragged-icon"></mat-icon>
        </div>
    </div>
</div>
<div class="actions-footer">
    <mat-dialog-actions>
        <button aum-button (click)="closeDialog()" color="basic">
            {{ 'aumico_button_cancel' | i18next }}
        </button>

        <button aum-button (click)="saveAndPrintNewSectionOrders()" color="primary">
            {{ 'aumico_reports_reorder_report_section_save_button' | i18next }}
        </button>
    </mat-dialog-actions>
</div>
